import { render, staticRenderFns } from "./requestCart.vue?vue&type=template&id=6b872e6a&scoped=true"
import script from "./requestCart.vue?vue&type=script&lang=js"
export * from "./requestCart.vue?vue&type=script&lang=js"
import style0 from "./requestCart.vue?vue&type=style&index=0&id=6b872e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b872e6a",
  null
  
)

export default component.exports